import { pick, path } from 'ramda';
import { all, put, takeEvery, take, race } from 'redux-saga/effects';
import { toSuccess, toError } from 'react-async-client';
import { message } from 'antd';

import { OPEN_MODAL_DOCUMENT } from 'constants/actionTypes';
import { openModalDocumentLink, openModalDocumentView } from 'actions/modalActions';
import { getDocumentInfo } from 'actions/asyncActions';
import { getDocumentPreviewType } from 'helpers/documentsHelpers';

export default function* documentModalSaga() {
    yield all([
        takeEvery(OPEN_MODAL_DOCUMENT, function* (action) {
            let payload = action.payload;
            let previewType = getDocumentPreviewType(action.payload);

            if (!previewType && !action.payload.fileType) {
                yield put(getDocumentInfo.withParams(pick(['id'], payload))(payload));

                const { success, error } = yield race({
                    success: take(toSuccess(getDocumentInfo.type)),
                    error: take(toError(getDocumentInfo.type))
                });

                if (success) {
                    previewType = getDocumentPreviewType(success.payload);

                    payload = {
                        ...payload,
                        ...success.payload,
                    };
                }

                if (error) {
                    return message.error(path(['payload', 'message'], error));
                }
            }

            const openModal = previewType ? openModalDocumentView : openModalDocumentLink;
            yield put(openModal(payload));
        })
    ]);
}
